import { createContext, useContext } from "react";
import { useRuntimeStatus } from "@/lib/useRuntimeStatus";

const Ctx = createContext({ status: null, loading: true, error: null });

export function RuntimeProvider({ children }) {
  const value = useRuntimeStatus();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useRuntime() {
  return useContext(Ctx);
}
